/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AssignInputs */

const cs_enum_assign = /** @type {(inputs: Enum_AssignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřazení`)
};

const en_enum_assign = /** @type {(inputs: Enum_AssignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign`)
};

/**
* | output |
* | --- |
* | "Assign" |
*
* @param {Enum_AssignInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_assign = /** @type {((inputs?: Enum_AssignInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AssignInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_assign(inputs)
	return cs_enum_assign(inputs)
});